module.exports = __webpack_public_path__ + "img/DE01176.ee5c2308.png";